import { Text } from "components/core/Text";
import { fireEvent } from "lib/ga";
import Image from "next/image";
import { useRouter } from "next/router";

import { Button } from "./Button";

type KakaoLoginButtonProps = {
    onSuccess?: () => void;
};

export const KakaoLoginButton = ({ onSuccess }: KakaoLoginButtonProps) => {
    const router = useRouter();

    const kakaoSignIn = () => {
        const redirect_uri = window.location.origin + "/api/oauth/kakao";
        const app_redirect_uri = window.location.href;

        const params = new URLSearchParams({
            client_id: process.env.NEXT_PUBLIC_KAKAO_REST_API_KEY,
            response_type: "code",
            redirect_uri,
            state: JSON.stringify({
                redirect_uri,
                app_redirect_uri
            })
        });

        fireEvent({
            event: "login",
            params: {
                method: "kakao",
                prev_webview_access: router.query.prev_webview_access === "true"
            }
        });

        window.location.href = `https://kauth.kakao.com/oauth/authorize?${params}`;
        onSuccess?.();
    };

    return (
        <Button
            className="w-full rounded-xl !bg-[#fddc3f] py-4
                shadow-[0px_3px_6px_rgba(0,0,0,0.16),0px_3px_6px_rgba(0,0,0,0.23)]"
            onClick={kakaoSignIn}
        >
            <div className="relative mr-3 h-[20.31px] w-[22px]">
                <Image alt="kakao" src="/img/kakao.png" fill />
            </div>
            <Text className="text-black" variant="subtitle2">
                카카오 로그인
            </Text>
        </Button>
    );
};
